module.exports = __webpack_public_path__ + "static/media/icon_mental_net.203d7763.svg";